import Marquee from "react-fast-marquee";
import "./avis.css";

import pfp1 from "../../../assets/img/avis/MicheleB.png";
import pfp2 from "../../../assets/img/avis/NicoleK.png";
import pfp3 from "../../../assets/img/avis/QuentinC.png";
import pfp4 from "../../../assets/img/avis/TomD.png";
import pfp5 from "../../../assets/img/avis/JeanC.png";

// 1. Données : modifiez ce tableau à volonté
const testimonials = [
  {
    id: 1,
    name: "Michèle Blouin",
    role: "Guide Local",
    avatar: pfp1,
    rating: 5,
    comment: `Jamais je n'ai vu un plombier aussi déterminé, persévérant et minutieux,
que Sylvain Lacroix, de l'entreprise NICE PLOMBERIE, pour venir à bout de ce problème
de plomberie qui dure depuis plus de 6 mois.

C'est une chance pour une entreprise d'avoir un employé de confiance, qui aime son métier
et fait un travail bien fait. 
...`,
  },
  {
    id: 2,
    name: "Tom Desandre",
    role: "Guide Local",
    avatar: pfp4,
    rating: 5,
    comment: `Très satisfait de l'intervention de Nice Plomberie pour régler notre souci de fuite dans notre maison. Une équipe agréable, réactive et très professionnelle. Un grand merci`,
  },
  {
    id: 3,
    name: "Nicole KARTALOVSKI",
    role: "",
    avatar: pfp2,
    rating: 5,
    comment: `Équipe très professionnelle et sympathique, heure de RV respectée mais pas que , Antony a pu déboucher ma canalisation en un temps record avec beaucoup de précision et de technicité
Un grand Merci`,
  },
  {
    id: 4,
    name: "QUINTIN Christine",
    role: "",
    avatar: pfp3,
    rating: 5,
    comment: `J'ai été très satisfaite de l'intervention du technicien : sympathique et efficace.
Merci Nice Plomberie`,
  },
  {
    id: 5,
    name: "jean-luc Cabaussel",
    role: "",
    avatar: pfp5,
    rating: 5,
    comment: `Je suis client depuis maintenant plusieurs années, et n’ai qu’à me féliciter des services de Nice Plomberie ! Tant au niveau de l’accueil téléphonique, que bien sûr lors des interventions techniques … une mention particuliere pour Arnaud, sa grande compétence et sa grande gentillesse.`,
  },
];

export default function TestimonialsMarquee() {
  return (
    <section className="TestimonialsMarquee">
      <h2 className="TestimonialsMarquee__title">Ce qu'ils en pensent</h2>
      <Marquee
        className="TestimonialsMarquee__marquee"
        behavior="scroll"
        direction="left"
        scrollamount="5"
        pauseOnHover={true}
      >
        {testimonials.map(({ id, name, role, avatar, rating, comment }) => (
          <div key={id} className="testimonial-card">
            <header className="tc-header">
              <img src={avatar} alt={name} className="tc-avatar" />
              <div className="tc-meta">
                <h4 className="tc-name">{name}</h4>
                <small className="tc-role">{role}</small>
              </div>
            </header>
            <p className="tc-comment">{comment}</p>
            <div className="tc-stars">
              {Array.from({ length: rating }).map((_, i) => (
                <svg
                  key={i}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="#FFD700"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 .587l3.668 7.568L24 9.423l-6 5.847L19.335 24 12 19.771 4.665 24 6 15.27 0 9.423l8.332-1.268z" />
                </svg>
              ))}
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
